/* eslint-disable */
import { useState, useEffect, useContext } from "react";
import AuthContext from "../../../../context/AuthProvider";
import axios from "axios";
import Cookies from "js-cookie";
import * as Icon from "react-bootstrap-icons";
import "./Login.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Toast from "../../../assetLibComponents/shared/Toast";
import "react-responsive-carousel/lib/styles/carousel.min.css";

//Redux-imports
import { getLoginContent } from "../../../../redux/actions/loginActions";
import { useDispatch } from "react-redux";

const Confirm = (props) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  let navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const FORGOT_URL = authCtx.forgotUrl;
  const [authToken, setAuthToken] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    const queryParams = new URLSearchParams(window.location.search);
    const ref = queryParams.get("ref");
    if (ref === "") {
      return;
    }
    setButtonLoader(true);
    try {
      const response = await axios.post(FORGOT_URL, {
        email: ref,
      });
      if (response?.data?.statusCode === "401") {
        Toast(response?.data?.message, "E");
        setButtonLoader(false);
      } else if (response?.data?.statusCode === "200") {
        Toast(response?.data?.message ? response?.data?.message : response?.data?.response, "S");
        navigate(`/checkemail?mailToken=${response?.data?.encrpt_url}&&ref=${email}`);    
        Cookies.set("fogetToken",response?.data?.encrpt_url)
        const randomId = Math.floor(Math.random() * 900000) + 100000; // Generate a random token
        const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
        Cookies.set("chatid", `backend-${randomId}`, { expires: expiryDate }); // Set the cookie with the random token
        setButtonLoader(false);
      } else {
        Toast(response?.data?.message ? response?.data?.message : response?.data?.response, "E");
        setButtonLoader(false);
      }
      setUsername("");
      setPassword("");
    } catch (err) {
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    setAuthToken(authCtx.auth);
  }, [setAuthToken, authCtx.auth, authToken]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const mailToken = queryParams.get("mailToken");
    const ref = queryParams.get("ref");
    if (Cookies.get("fogetToken") !== mailToken) {
      navigate("/")
    } else {
      dispatch(getLoginContent());
      setEmail(ref);
    }
    
  }, []);

  const title = props.title;
  useEffect(() => {
    document.title = `Get Started with Zoi | ${title}`;
    window.scrollTo(0, 0);
  }, [title, navigate]);

  return (
    <div title={props.title} className="mt-10">
        <div>
            <div className="text-center mx-0 my-20">
                <Icon.Envelope className="text-[var(--brand-primary)] border-[var(--brand-primary)] flex text-[85px] w-[100px] h-[85px] m-auto p-3.5 rounded-[50%] border-4 border-solid" />
                <>
                    <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                        Check your E-mail.
                    </h2>
                    <p className="mt-2 text-sm leading-6 text-gray-500">
                        We've sent you instructions on how to reset your password.
                    </p>
                </>
                {buttonLoader !== true && <p className="text-center mt-10 text-sm text-gray-500">
                   Didn't receive it yet? {' '}
                    <span onClick={handleSubmit} className="cursor-pointer font-semibold leading-6 text-[var(--brand-primary)] hover:text-indigo-500">
                    Send again.
                    </span>
                </p> }
            </div>
        </div>
    </div>
  );
};

export default Confirm;
